/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IntCalculationDataTransferObject } from './IntCalculationDataTransferObject';
import {
    IntCalculationDataTransferObjectFromJSON,
    IntCalculationDataTransferObjectFromJSONTyped,
    IntCalculationDataTransferObjectToJSON,
    IntCalculationDataTransferObjectToJSONTyped,
} from './IntCalculationDataTransferObject';
import type { MoneyCalculationDataTransferObject } from './MoneyCalculationDataTransferObject';
import {
    MoneyCalculationDataTransferObjectFromJSON,
    MoneyCalculationDataTransferObjectFromJSONTyped,
    MoneyCalculationDataTransferObjectToJSON,
    MoneyCalculationDataTransferObjectToJSONTyped,
} from './MoneyCalculationDataTransferObject';
import type { NullableMoneyCalculationDataTransferObject } from './NullableMoneyCalculationDataTransferObject';
import {
    NullableMoneyCalculationDataTransferObjectFromJSON,
    NullableMoneyCalculationDataTransferObjectFromJSONTyped,
    NullableMoneyCalculationDataTransferObjectToJSON,
    NullableMoneyCalculationDataTransferObjectToJSONTyped,
} from './NullableMoneyCalculationDataTransferObject';

/**
 * 
 * @export
 * @interface SingleSourceData
 */
export interface SingleSourceData {
    /**
     * 
     * @type {NullableMoneyCalculationDataTransferObject}
     * @memberof SingleSourceData
     */
    averageOrderValueNet?: NullableMoneyCalculationDataTransferObject;
    /**
     * 
     * @type {NullableMoneyCalculationDataTransferObject}
     * @memberof SingleSourceData
     */
    averageOrderValueGross?: NullableMoneyCalculationDataTransferObject;
    /**
     * 
     * @type {boolean}
     * @memberof SingleSourceData
     */
    purchaseCostCompleteNet?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SingleSourceData
     */
    purchaseCostCompleteGross?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SingleSourceData
     */
    purchaseCostCompleteNetPreviousPeriod?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SingleSourceData
     */
    purchaseCostCompleteGrossPreviousPeriod?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SingleSourceData
     */
    sourceName?: string;
    /**
     * 
     * @type {MoneyCalculationDataTransferObject}
     * @memberof SingleSourceData
     */
    spendMarketing?: MoneyCalculationDataTransferObject;
    /**
     * 
     * @type {IntCalculationDataTransferObject}
     * @memberof SingleSourceData
     */
    orderAmountNet?: IntCalculationDataTransferObject;
    /**
     * 
     * @type {IntCalculationDataTransferObject}
     * @memberof SingleSourceData
     */
    orderAmountGross?: IntCalculationDataTransferObject;
    /**
     * 
     * @type {MoneyCalculationDataTransferObject}
     * @memberof SingleSourceData
     */
    turnoverNet?: MoneyCalculationDataTransferObject;
    /**
     * 
     * @type {MoneyCalculationDataTransferObject}
     * @memberof SingleSourceData
     */
    turnoverGross?: MoneyCalculationDataTransferObject;
    /**
     * 
     * @type {MoneyCalculationDataTransferObject}
     * @memberof SingleSourceData
     */
    spendGoodsNet?: MoneyCalculationDataTransferObject;
    /**
     * 
     * @type {MoneyCalculationDataTransferObject}
     * @memberof SingleSourceData
     */
    spendGoodsGross?: MoneyCalculationDataTransferObject;
    /**
     * 
     * @type {boolean}
     * @memberof SingleSourceData
     */
    purchaseCostQualityAvailable?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SingleSourceData
     */
    purchaseCostQualityAvailablePreviousPeriod?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SingleSourceData
     */
    purchaseCostUnknownNet?: number;
    /**
     * 
     * @type {number}
     * @memberof SingleSourceData
     */
    purchaseCostUnknownGross?: number;
    /**
     * 
     * @type {number}
     * @memberof SingleSourceData
     */
    purchaseCostEstimatedNet?: number;
    /**
     * 
     * @type {number}
     * @memberof SingleSourceData
     */
    purchaseCostEstimatedGross?: number;
    /**
     * 
     * @type {number}
     * @memberof SingleSourceData
     */
    purchaseCostUnknownNetPreviousPeriod?: number;
    /**
     * 
     * @type {number}
     * @memberof SingleSourceData
     */
    purchaseCostUnknownGrossPreviousPeriod?: number;
    /**
     * 
     * @type {number}
     * @memberof SingleSourceData
     */
    purchaseCostEstimatedNetPreviousPeriod?: number;
    /**
     * 
     * @type {number}
     * @memberof SingleSourceData
     */
    purchaseCostEstimatedGrossPreviousPeriod?: number;
}

/**
 * Check if a given object implements the SingleSourceData interface.
 */
export function instanceOfSingleSourceData(value: object): value is SingleSourceData {
    return true;
}

export function SingleSourceDataFromJSON(json: any): SingleSourceData {
    return SingleSourceDataFromJSONTyped(json, false);
}

export function SingleSourceDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SingleSourceData {
    if (json == null) {
        return json;
    }
    return {
        
        'averageOrderValueNet': json['averageOrderValueNet'] == null ? undefined : NullableMoneyCalculationDataTransferObjectFromJSON(json['averageOrderValueNet']),
        'averageOrderValueGross': json['averageOrderValueGross'] == null ? undefined : NullableMoneyCalculationDataTransferObjectFromJSON(json['averageOrderValueGross']),
        'purchaseCostCompleteNet': json['purchaseCostCompleteNet'] == null ? undefined : json['purchaseCostCompleteNet'],
        'purchaseCostCompleteGross': json['purchaseCostCompleteGross'] == null ? undefined : json['purchaseCostCompleteGross'],
        'purchaseCostCompleteNetPreviousPeriod': json['purchaseCostCompleteNetPreviousPeriod'] == null ? undefined : json['purchaseCostCompleteNetPreviousPeriod'],
        'purchaseCostCompleteGrossPreviousPeriod': json['purchaseCostCompleteGrossPreviousPeriod'] == null ? undefined : json['purchaseCostCompleteGrossPreviousPeriod'],
        'sourceName': json['sourceName'] == null ? undefined : json['sourceName'],
        'spendMarketing': json['spendMarketing'] == null ? undefined : MoneyCalculationDataTransferObjectFromJSON(json['spendMarketing']),
        'orderAmountNet': json['orderAmountNet'] == null ? undefined : IntCalculationDataTransferObjectFromJSON(json['orderAmountNet']),
        'orderAmountGross': json['orderAmountGross'] == null ? undefined : IntCalculationDataTransferObjectFromJSON(json['orderAmountGross']),
        'turnoverNet': json['turnoverNet'] == null ? undefined : MoneyCalculationDataTransferObjectFromJSON(json['turnoverNet']),
        'turnoverGross': json['turnoverGross'] == null ? undefined : MoneyCalculationDataTransferObjectFromJSON(json['turnoverGross']),
        'spendGoodsNet': json['spendGoodsNet'] == null ? undefined : MoneyCalculationDataTransferObjectFromJSON(json['spendGoodsNet']),
        'spendGoodsGross': json['spendGoodsGross'] == null ? undefined : MoneyCalculationDataTransferObjectFromJSON(json['spendGoodsGross']),
        'purchaseCostQualityAvailable': json['purchaseCostQualityAvailable'] == null ? undefined : json['purchaseCostQualityAvailable'],
        'purchaseCostQualityAvailablePreviousPeriod': json['purchaseCostQualityAvailablePreviousPeriod'] == null ? undefined : json['purchaseCostQualityAvailablePreviousPeriod'],
        'purchaseCostUnknownNet': json['purchaseCostUnknownNet'] == null ? undefined : json['purchaseCostUnknownNet'],
        'purchaseCostUnknownGross': json['purchaseCostUnknownGross'] == null ? undefined : json['purchaseCostUnknownGross'],
        'purchaseCostEstimatedNet': json['purchaseCostEstimatedNet'] == null ? undefined : json['purchaseCostEstimatedNet'],
        'purchaseCostEstimatedGross': json['purchaseCostEstimatedGross'] == null ? undefined : json['purchaseCostEstimatedGross'],
        'purchaseCostUnknownNetPreviousPeriod': json['purchaseCostUnknownNetPreviousPeriod'] == null ? undefined : json['purchaseCostUnknownNetPreviousPeriod'],
        'purchaseCostUnknownGrossPreviousPeriod': json['purchaseCostUnknownGrossPreviousPeriod'] == null ? undefined : json['purchaseCostUnknownGrossPreviousPeriod'],
        'purchaseCostEstimatedNetPreviousPeriod': json['purchaseCostEstimatedNetPreviousPeriod'] == null ? undefined : json['purchaseCostEstimatedNetPreviousPeriod'],
        'purchaseCostEstimatedGrossPreviousPeriod': json['purchaseCostEstimatedGrossPreviousPeriod'] == null ? undefined : json['purchaseCostEstimatedGrossPreviousPeriod'],
    };
}

export function SingleSourceDataToJSON(json: any): SingleSourceData {
    return SingleSourceDataToJSONTyped(json, false);
}

export function SingleSourceDataToJSONTyped(value?: SingleSourceData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'averageOrderValueNet': NullableMoneyCalculationDataTransferObjectToJSON(value['averageOrderValueNet']),
        'averageOrderValueGross': NullableMoneyCalculationDataTransferObjectToJSON(value['averageOrderValueGross']),
        'purchaseCostCompleteNet': value['purchaseCostCompleteNet'],
        'purchaseCostCompleteGross': value['purchaseCostCompleteGross'],
        'purchaseCostCompleteNetPreviousPeriod': value['purchaseCostCompleteNetPreviousPeriod'],
        'purchaseCostCompleteGrossPreviousPeriod': value['purchaseCostCompleteGrossPreviousPeriod'],
        'sourceName': value['sourceName'],
        'spendMarketing': MoneyCalculationDataTransferObjectToJSON(value['spendMarketing']),
        'orderAmountNet': IntCalculationDataTransferObjectToJSON(value['orderAmountNet']),
        'orderAmountGross': IntCalculationDataTransferObjectToJSON(value['orderAmountGross']),
        'turnoverNet': MoneyCalculationDataTransferObjectToJSON(value['turnoverNet']),
        'turnoverGross': MoneyCalculationDataTransferObjectToJSON(value['turnoverGross']),
        'spendGoodsNet': MoneyCalculationDataTransferObjectToJSON(value['spendGoodsNet']),
        'spendGoodsGross': MoneyCalculationDataTransferObjectToJSON(value['spendGoodsGross']),
        'purchaseCostQualityAvailable': value['purchaseCostQualityAvailable'],
        'purchaseCostQualityAvailablePreviousPeriod': value['purchaseCostQualityAvailablePreviousPeriod'],
        'purchaseCostUnknownNet': value['purchaseCostUnknownNet'],
        'purchaseCostUnknownGross': value['purchaseCostUnknownGross'],
        'purchaseCostEstimatedNet': value['purchaseCostEstimatedNet'],
        'purchaseCostEstimatedGross': value['purchaseCostEstimatedGross'],
        'purchaseCostUnknownNetPreviousPeriod': value['purchaseCostUnknownNetPreviousPeriod'],
        'purchaseCostUnknownGrossPreviousPeriod': value['purchaseCostUnknownGrossPreviousPeriod'],
        'purchaseCostEstimatedNetPreviousPeriod': value['purchaseCostEstimatedNetPreviousPeriod'],
        'purchaseCostEstimatedGrossPreviousPeriod': value['purchaseCostEstimatedGrossPreviousPeriod'],
    };
}

